var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#2878B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 25.9305V32.8251H30.9641V26.3509C30.9641 24.7534 30.3756 23.6603 28.9462 23.6603C27.8531 23.6603 27.1805 24.417 26.9283 25.0897C26.8442 25.3419 26.7601 25.6782 26.7601 26.0987V32.8251H22.7242C22.7242 32.8251 22.8083 21.8946 22.7242 20.8016H26.7601V22.4832C27.2646 21.6424 28.2735 20.4652 30.3756 20.4652C32.9821 20.4652 35 22.2309 35 25.9305ZM18.5202 15C17.1749 15 16.25 15.9249 16.25 17.102C16.25 18.2791 17.0908 19.204 18.4361 19.204C19.8655 19.204 20.7063 18.2791 20.7063 17.102C20.7904 15.8408 19.9495 15 18.5202 15ZM16.5022 32.8251H20.5381V20.8016H16.5022V32.8251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1fb993389f57f42fc47f73ed835af1d4.svg";
export { ForwardRef as ReactComponent };